import { render, staticRenderFns } from "./BankPass.vue?vue&type=template&id=960a0a40&scoped=true&"
import script from "./BankPass.vue?vue&type=script&lang=js&"
export * from "./BankPass.vue?vue&type=script&lang=js&"
import style0 from "./BankPass.vue?vue&type=style&index=0&id=960a0a40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960a0a40",
  null
  
)

export default component.exports